<div
  #target
  (mouseleave)="toggleModdal($event)"
  (mouseenter)="checkEvent($event)"
>
  <ng-container *ngIf="isHeader">
    <wz-header-afi *ngIf="isSlugQuoteRequest()"></wz-header-afi>
  </ng-container>
  <!-- modal info-->
  <div *ngIf="isSlugQuoteRequest()">
    <div
      *ngIf="displayM"
      id="infoModal"
      class="modal"
      (click)="clickOutside($event)"
    >
      <div class="modal-content-e" id="modal-content">
        <div class="modal-header-e">
          <img src="assets/img/close-modal.svg" alt="" (click)="closeModal()" />
        </div>
        <div class="modal-body-e">
          <div class="content-img">
            <img src="assets/img/modal-img-faq.svg" alt="" />
          </div>
          <div class="content-text">
            <div class="text">
              Encore un effort et vous pourrez économiser jusqu’à
              <b class="blue-text">399€¹</b> par an
            </div>
          </div>
          <div class="input-btn">
            <button class="button-modal" (click)="closeModal()">
              J'économise
            </button>
          </div>
          <div class="saviezVous">
            <p class="saviezVous__titre">Le saviez-vous ?</p>
            <p class="saviezVous__content">
              Vous pouvez prendre un rendez-vous téléphonique avec un conseiller
              santé.
            </p>
          </div>
          <div class="prendre-rendez-vous">
            <a
              href="https://calendly.com/conseiller_mtxsante/rdv_commercial"
              class="prendre-rendez-vous__link"
              target="_blank"
              ><img
                src="../../../../../../assets/img/iconeRDV.svg"
                alt="Prendre rendez-vous"
              />
              Prendre rendez-vous</a
            >
          </div>
          <div class="pop-in-mention">
            <span>
              <sup><b>1</b></sup> Les clients n’ayant pas augmenté leur garantie
              économisent en moyenne 399,60€ par an par rapport à leur précédent
              contrat. Étude réalisée du 29/01/2025 au 10/02/2025 sur nos
              nouveaux clients. Résultats basés sur 468 répondants à l’enquête.
              Détail de l’étude disponible sur simple demande à l’adresse
              <a href="mailto:dpo-sante@meilleurtaux.com"
                ><u>dpo-sante&#64;meilleurtaux.com</u></a
              >.
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    class="app-tunnel app-afi-subscription main-container no-sidenav drawer-closed"
  >
    <div class="content base-content">
      <div *ngIf="loading" class="loading-wazari">
        <wz-content-loader>chargement...</wz-content-loader>
      </div>
      <router-outlet> </router-outlet>
    </div>
  </div>
</div>
